import { render } from "./user-panel.vue?vue&type=template&id=b118bd8c"
import script from "./user-panel.vue?vue&type=script&lang=js"
export * from "./user-panel.vue?vue&type=script&lang=js"

import "./user-panel.vue?vue&type=style&index=0&id=b118bd8c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__